import { GameEventDto } from 'modules/games/domain/interfaces/game-event-dto';
import { addGameEvent } from 'modules/games/store/actions';

import { ChampionshipSettings } from 'modules/championship/domain/interfaces/championship-settings';
import { championshipSettingsSelector } from 'modules/championship/store/championship/selectors';
import { useCallback, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import UDButton from 'ud-ui/components/button';
import Modal from 'ud-ui/components/modal';
import { GameDetails } from 'modules/games/domain/interfaces/game-details';
import { getPeriodsSettings } from 'modules/games/domain/utils/match-periods-settings';
import { GameEventForm } from '../game-event-form';
import * as styles from './game-event-creator.styles';

type GameEventCreatorProps = {
  isLoading: boolean;
  teamIndex: number;
  game: GameDetails | null;
  championshipId: number;
};

export const GameEventCreator = (props: GameEventCreatorProps) => {
  const dispatch = useDispatch();
  const settings = useSelector(championshipSettingsSelector(props.championshipId));
  const periodSettings = getPeriodsSettings(settings || ({} as ChampionshipSettings));

  const { isLoading, teamIndex, game } = props;

  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  const onButtonClick = useCallback(() => {
    open();
  }, [open]);

  const handleAddEvent = useCallback(
    (values: GameEventDto) => {
      dispatch(
        addGameEvent({
          data: values,
          periodSettings,
        }),
      );
      close();
    },
    [close, dispatch, periodSettings],
  );

  const initialValues = game ? { teamId: game.teams[teamIndex].id } : { teamId: 0 };

  return (
    <styles.GameEventCreatorContainer className={isLoading ? 'is-loading' : ''}>
      {game && !isLoading && (
        <>
          <UDButton variant="primary" type="button" onClick={onButtonClick}>
            + Добавить событие
          </UDButton>

          <Modal show={isOpen} onClose={close} size="md">
            <Modal.Header title="Добавить событие матча" />
            <Modal.Body>
              <GameEventForm initialValues={initialValues} members={game.teams[teamIndex].members} onSubmit={handleAddEvent} />
            </Modal.Body>
          </Modal>
        </>
      )}
    </styles.GameEventCreatorContainer>
  );
};
